import axios from "./axios";

import { userData } from "./Currentuserdata";

export default {
    /**
     * Get All Customers
     * @api {Get} manageCustomerOptica
     */
    getCustomersOptica(data) {
        const options = {
            method: "GET",
            url: "manageCustomerOptica",
            headers: { "content-type": "application/json" },
            params: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    },
    addCustomerOpticaExamData(data) {
        const user = userData();
        const options = {
            method: "POST",
            url: "manageCustomerOptica",
            headers: { "content-type": "application/json" },
            data: {
                ...data,
                idUser: user.id
            },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    },
    logicalDeleteCustomerExam(id) {
        const user = userData();
        const options = {
            method: "PUT",
            url: `manageCustomerOptica/logicaldelete/${id}`,
            headers: { "content-type": "application/json" },
            data: {
                ID_Business: user.businessid,
                ID_User_Delete: user.id
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    }
}